// TODO: perhaps move these to more general location

export const chunksToBlob = (chunks: Blob[]) => new Blob(chunks, { type: chunks[0].type });

// copied from AudioAttributeInput.tsx
export const blobToBase64 = (blob: Blob) => {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result as string);
    };
    reader.readAsDataURL(blob);
  });
};
